import { useCallback, useEffect, useRef, useState } from 'react'

/** 带 localStorage 持久化的 state（参考站用 rh_ 前缀，这里用 hw_ 前缀） */
export function useLocalStorage<T>(key: string, initial: T, prefix = 'hw_') {
  const fullKey = `${prefix}${key}`
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(fullKey)
      if (raw == null) return initial
      const parsed = JSON.parse(raw) as T
      // 对象型做一层浅合并，保证新增字段有默认值
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && initial && typeof initial === 'object') {
        return { ...(initial as object), ...(parsed as object) } as T
      }
      return parsed
    } catch {
      return initial
    }
  })

  const ref = useRef(value)
  ref.current = value

  useEffect(() => {
    try {
      localStorage.setItem(fullKey, JSON.stringify(value))
    } catch {
      /* 隐私模式或超配额，忽略 */
    }
  }, [fullKey, value])

  const reset = useCallback(() => setValue(initial), [initial])
  return [value, setValue, reset] as const
}
